<template>
  <div>
    <template v-if="seletorOtimizadoAtivo">
      <div v-if="!exibirListagemDireta" class="selector-paginado">
        <div class="selector-paginado__cabecalho">
          <div>
            <span class="selector-paginado__titulo">
              {{ translatedTitle
              }}<span v-if="obrigatorio" class="required-mark"> *</span>
            </span>
            <span class="selector-paginado__ajuda">
              {{ $t("Clique_em_um_registro_para_selecionar") }}
            </span>
          </div>
          <v-btn
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              px-6
              ms-3
            "
            height="39"
            :loading="loadingListagemComponent"
            :aria-label="$t('Visualizar_e_selecionar')"
            @click="openListagemPadrao"
          >
            <v-icon left>mdi-format-list-bulleted</v-icon>
            {{ $t("Visualizar_e_selecionar") }}
          </v-btn>
        </div>

        <div v-if="recursoSelecionado" class="selector-paginado__selecionado">
          <v-icon color="success" class="mr-3">mdi-check-circle</v-icon>
          <div class="min-width-0">
            <span class="selector-paginado__rotulo">
              {{ $t("Registro_selecionado_atualmente") }}
            </span>
            <div class="selector-paginado__valor">
              {{ textoRecursoSelecionado }}
            </div>
          </div>
          <v-spacer />
          <v-btn
            icon
            :title="$t('Limpar')"
            :aria-label="$t('Limpar')"
            @click="limparSelecaoPaginada"
          >
            <v-icon color="grey">mdi-close-circle-outline</v-icon>
          </v-btn>
        </div>
        <div v-else class="selector-paginado__vazio">
          <v-icon color="grey lighten-1" class="mr-3">
            mdi-database-search-outline
          </v-icon>
          <span>{{ $t("Selecionar_registro") }}</span>
        </div>
      </div>

      <component
        :is="exibirListagemDireta ? 'div' : 'v-dialog'"
        v-if="exibirListagemDireta || dialogListagemPadrao"
        v-bind="seletorContainerProps"
        @input="dialogListagemPadrao = $event"
      >
        <v-card
          :flat="exibirListagemDireta"
          :class="{
            'selector-paginado__dialog': !exibirListagemDireta,
            'selector-paginado__inline': exibirListagemDireta,
          }"
        >
          <v-card-title class="selector-paginado__dialog-title">
            <div>
              <div class="text-h6 font-weight-bold">{{ translatedTitle }}</div>
              <div class="text-caption font-weight-regular text--secondary">
                {{ $t("Clique_em_um_registro_para_selecionar") }}
              </div>
            </div>
            <v-spacer />
            <v-btn
              v-if="!exibirListagemDireta"
              icon
              :aria-label="$t('Fechar')"
              @click="closeListagemPadrao"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text class="selector-paginado__dialog-content pa-0">
            <div
              v-if="loadingListagemComponent"
              class="d-flex flex-column align-center justify-center py-12"
            >
              <v-progress-circular indeterminate color="primary" />
              <span class="text-caption text--secondary mt-3">
                {{ $t("Carregando_registros") }}
              </span>
            </div>
            <v-alert
              v-else-if="erroCarregamentoRecursos"
              type="error"
              text
              class="ma-4"
            >
              <div class="d-flex align-center justify-space-between">
                <span>{{ $t("Tente_novamente_mais_tarde") }}</span>
                <v-btn text color="error" @click="tentarNovamenteCarregamento">
                  {{ $t("Tente_novamente") }}
                </v-btn>
              </div>
            </v-alert>
            <component
              :is="listagemComponent"
              v-else-if="temListagemPadrao && listagemComponent"
              modo-selecao-recurso
              @selecionar-recurso="selecionarRecursoDaListagem"
            />
            <template v-else-if="!temListagemPadrao">
              <div class="selector-paginado__busca">
                <v-text-field
                  v-model="search"
                  :label="$t('Procurar')"
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  dense
                  flat
                  filled
                  solo
                  clearable
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                />
                <v-btn
                  v-if="showCadastroRapidoButton"
                  v-can="resolvedInsertPermission"
                  class="
                    font-weight-bold
                    text-none
                    btn-secondary
                    bg-gradient-light
                    px-5
                  "
                  height="39"
                  :loading="loadingCadastroComponent"
                  @click="openCadastroModal"
                >
                  <v-icon left>mdi-plus-circle-outline</v-icon>
                  {{ $t("novo_registro") }}
                </v-btn>
              </div>

              <v-data-table
                :headers="headersSelecao"
                :items="tableItems"
                :search="search"
                item-key="id"
                :items-per-page="itemsPerPage"
                @page-count="pageCount = $event"
                @click:row="selecionarRecursoDaTabela"
                mobile-breakpoint="0"
                class="table selector-paginado__table"
              >
                <template v-slot:[`item.inicioVigencia`]="{ item }">
                  <span>{{ item.inicioVigencia | dataParaLeitura }}</span>
                </template>
                <template v-slot:[`item.finalVigencia`]="{ item }">
                  <span>{{ item.finalVigencia | dataParaLeitura }}</span>
                </template>
                <template v-slot:[`item.cpf`]="{ item }">
                  <span>{{ item.cpf | VMask("###.###.###-##") }}</span>
                </template>
                <template v-slot:[`item.published`]="{ item }">
                  <span>{{ item.published | dataParaLeitura }}</span>
                </template>
                <template v-slot:[`item.inicioPeriodo`]="{ item }">
                  {{ item.inicioPeriodo | dataParaLeitura }}
                </template>
                <template v-slot:[`item.finalPeriodo`]="{ item }">
                  {{ item.finalPeriodo | dataParaLeitura }}
                </template>
                <template v-slot:[`item.updated`]="{ item }">
                  <span>{{ item.updated | dataParaLeitura }}</span>
                </template>
                <template v-slot:[`item.valor`]="{ item }">
                  <span>{{ item.valor | formatoMonetario }}</span>
                </template>
                <template v-slot:[`item.situacao`]="{ item }">
                  {{ $t(item.situacao) }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  {{ $t(item.status) }}
                </template>
                <template v-slot:[`item.tipo`]="{ item }">
                  {{ $t(item.tipo) }}
                </template>
                <template v-slot:[`item.vencimento`]="{ item }">
                  <span>{{ item.vencimento | dataParaLeitura }}</span>
                </template>
                <template v-slot:[`item.saldo`]="{ item }">
                  <span>{{ item.saldo | formatoMonetario }}</span>
                </template>
                <template v-slot:[`item.inconsistencia`]="{ item }">
                  <span>{{ $t(item.inconsistencia ? "sim" : "nao") }}</span>
                </template>
                <template v-slot:[`item.retencao`]="{ item }">
                  <span>{{ $t(item.retencao ? "sim" : "nao") }}</span>
                </template>
                <template v-slot:[`item.escalaIntermitente`]="{ item }">
                  <span>
                    {{ $t(item.escalaIntermitente ? "sim" : "nao") }}
                  </span>
                </template>
                <template v-slot:[`item.disponivel`]="{ item }">
                  <span>{{ $t(item.disponivel ? "sim" : "nao") }}</span>
                </template>
                <template v-slot:[`item.statusComum`]="{ item }">
                  {{ $t(item.statusComum) }}
                </template>
                <template v-slot:[`item.nRegistro`]="{ item }">
                  <span v-if="item.nRegistro">{{
                    item.nRegistro
                      | VMask(
                        item.nRegistro.length > 11
                          ? $t("maskCNPJ")
                          : $t("maskCPF")
                      )
                  }}</span>
                </template>
              </v-data-table>
            </template>
          </v-card-text>
        </v-card>
      </component>
    </template>

    <template v-else>
      <div class="card-header-padding">
        <div>
          <h5 class="font-weight-bold text-h5 text-typo mb-0">
            {{ translatedTitle }}
          </h5>
          <p class="text-sm text-body mb-0">
            {{ $t("Clique_para_selecionar") }}
          </p>
        </div>
        <div class="d-flex align-center">
          <v-col cols="12" md="5">
            <v-text-field
              hide-details
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
              height="39"
              v-model="search"
              :label="$t('Procurar')"
            >
              <template slot="prepend-inner">
                <v-icon color="#adb5bd" size=".875rem">fas fa-search</v-icon>
              </template></v-text-field
            >
          </v-col>
          <v-btn
            v-if="showCadastroRapidoButton"
            v-can="resolvedInsertPermission"
            icon
            :title="$t('novo_registro')"
            :aria-label="$t('novo_registro')"
            :loading="loadingCadastroComponent"
            @click="openCadastroModal"
          >
            <v-icon color="primary" size="28">mdi-plus-circle</v-icon>
          </v-btn>
        </div>
      </div>

      <v-card-text class="px-0 py-0">
        <v-data-table
          :headers="normalizedHeaders"
          :items="tableItems"
          :search="search"
          show-select
          item-key="id"
          :single-select="!this.selectMultiple"
          v-model="recurso"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          mobile-breakpoint="0"
          class="table"
        >
          <template v-slot:[`item.inicioVigencia`]="{ item }">
            <span>{{ item.inicioVigencia | dataParaLeitura }}</span>
          </template>
          <template v-slot:[`item.finalVigencia`]="{ item }">
            <span>{{ item.finalVigencia | dataParaLeitura }}</span>
          </template>

          <template v-slot:[`item.cpf`]="{ item }">
            <span>{{ item.cpf | VMask("###.###.###-##") }}</span>
          </template>

          <template v-slot:[`item.published`]="{ item }">
            <span>{{ item.published | dataParaLeitura }}</span>
          </template>
          <template v-slot:[`item.inicioPeriodo`]="{ item }">
            {{ item.inicioPeriodo | dataParaLeitura }}
          </template>
          <template v-slot:[`item.finalPeriodo`]="{ item }">
            {{ item.finalPeriodo | dataParaLeitura }}
          </template>
          <template v-slot:[`item.updated`]="{ item }">
            <span>{{ item.updated | dataParaLeitura }}</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editPessoa(item.id)"
              >ni-ruler-pencil</v-icon
            >
          </template>

          <template v-slot:[`item.valor`]="{ item }">
            <span>{{ item.valor | formatoMonetario }}</span>
          </template>

          <template v-slot:[`item.situacao`]="{ item }">
            {{ $t(item.situacao) }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            {{ $t(item.status) }}
          </template>

          <template v-slot:[`item.tipo`]="{ item }">
            {{ $t(item.tipo) }}
          </template>

          <template v-slot:[`item.vencimento`]="{ item }">
            <span>{{ item.vencimento | dataParaLeitura }}</span>
          </template>

          <template v-slot:[`item.saldo`]="{ item }">
            <span>{{ item.saldo | formatoMonetario }}</span>
          </template>

          <template v-slot:[`item.inconsistencia`]="{ item }">
            <span>{{ $t(item.inconsistencia ? "sim" : "nao") }}</span>
          </template>

          <template v-slot:[`item.retencao`]="{ item }">
            <span>{{ $t(item.retencao) ? $t("sim") : $t("nao") }}</span>
          </template>

          <template v-slot:[`item.escalaIntermitente`]="{ item }">
            <span>{{
              $t(item.escalaIntermitente) ? $t("sim") : $t("nao")
            }}</span>
          </template>

          <template v-slot:[`item.disponivel`]="{ item }">
            <span>{{ $t(item.disponivel) ? $t("sim") : $t("nao") }}</span>
          </template>

          <template v-slot:[`item.statusComum`]="{ item }">
            {{ $t(item.statusComum) }}
          </template>

          <template v-slot:[`item.nRegistro`]="{ item }">
            <span v-if="item.nRegistro">{{
              item.nRegistro
                | VMask(
                  item.nRegistro.length > 11 ? $t("maskCNPJ") : $t("maskCPF")
                )
            }}</span>
          </template>

          <template> </template>
        </v-data-table>
      </v-card-text>

      <!-- <v-card-actions class="card-padding">
        <v-row>
          <v-col cols="6" lg="6" class="d-flex align-center">
            <span class="text-body me-3 text-sm"
              >{{ $t("Itens_por_pagina") }}:</span
            >
            <v-col cols="3" sm="3">
              <v-select
                v-model="pageSize"
                :items="pageSizes"
                @change="handlePageSizeChange"
                :disabled="this.isSearching"
                class="input-style font-size-input text-light-input"
              ></v-select>
            </v-col>
          </v-col>
          <v-col cols="6" class="ml-auto d-flex justify-end">
            <v-pagination
              prev-icon="fa fa-angle-left"
              next-icon="fa fa-angle-right"
              class="pagination"
              color="#516a78ee"
              v-model="page"
              :length="isSearching ? filteredItems.length : totalPages"
              @input="handlePageChange"
              :disabled="isSearching"
              circle
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-actions> -->
    </template>

    <v-dialog
      v-model="dialogCadastro"
      persistent
      max-width="100%"
      @keydown.esc.native.stop.prevent="onEscCadastroRapido"
    >
      <component
        :is="insertComponent"
        v-if="insertComponent"
        @submitSuccessInsert="onSubmitSuccessInsert"
        @submitErrorInsert="onSubmitErrorInsert"
        @closeModalInsert="closeCadastroModal"
      />
    </v-dialog>
  </div>
</template>

<script>
import { componentPaths } from "@/router/componentPaths";
import DataService from "@/services/ComumDataService";
import { translateIfMessageExists } from "@/utils/i18n";

import createNumberMask from "text-mask-addons/dist/createNumberMask";

const currencyMask = createNumberMask({
  prefix: "R$",
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: false,
});

function normalizeIdentity(value) {
  if (value === null || typeof value === "undefined") return "";
  return String(value);
}

const URL_CADASTRO_MAP = {
  beneficioperiodoapuracao: "cadastro.BeneficioPeriodoApuracao",
  centrocustos: "cadastro.CentroCusto",
  cfops: "cadastro.Cfop",
  clientes: "cadastro.Cliente",
  comprapedidos: "cadastro.CompraPedido",
  contabancarias: "cadastro.ContaBancaria",
  contratos: "cadastro.Contrato",
  escoposervico: "cadastro.EscopoServico",
  funcionariocargos: "cadastro.FuncionarioCargo",
  funcionarioescalatrabalho: "cadastro.FuncionarioEscalaTrabalho",
  funcionariopontoperiodos: "cadastro.FuncionarioPontoPeriodo",
  funcionarios: "cadastro.Funcionario",
  funcionariosindicatos: "cadastro.FuncionarioSindicato",
  metodocobrancas: "cadastro.MetodoCobranca",
  parametrizacaofiscal: "cadastro.ParametrizacaoFiscal",
  pessoas: "cadastro.Pessoa",
  postostrabalho: "cadastro.PostoTrabalho",
  registradorpontoexternos: "cadastro.RegistradorPontoExterno",
  registrostarefaperiodo: "cadastro.RegistroTarefaPeriodo",
};

const URL_LISTAGEM_MAP = {
  clientes: "clientes",
  funcionariocargos: "FuncionarioCargos",
  funcionarioescalatrabalho: "FuncionarioEscalaTrabalhos",
  funcionariosindicatos: "FuncionarioSindicatos",
  funcionarios: "Funcionarios",
  pessoas: "Pessoas",
  postostrabalho: "PostoTrabalhos",
};

export default {
  name: "TabelaSelecionaRecurso",

  props: {
    titulo: { type: String, required: false, default: "Pessoa" },
    fieldName: { type: String, required: false, default: "" },
    payload: {
      default() {
        return {};
      },
    },
    editar: { type: Boolean, default: false },
    url: { type: String, required: false },
    headers: { type: Array, required: true },
    selectMultiple: { type: Boolean, default: false },
    cadastroUrl: { type: String, required: false, default: "" },
    insertPermission: { type: String, required: false, default: "" },
    enableCadastroRapido: { type: Boolean, required: false, default: true },
    obrigatorio: { type: Boolean, required: false, default: false },
    usarListagemPadrao: { type: Boolean, required: false, default: false },
    exibirTabelaInline: { type: Boolean, required: false, default: false },
    manterCompactoSemSelecao: {
      type: Boolean,
      required: false,
      default: false,
    },
    listagemNome: { type: String, required: false, default: "" },
    desabilitarListagemPadrao: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemText: {
      type: [Function, String],
      required: false,
      default: "descricao",
    },
  },

  data() {
    let recursoInicial = [];
    try {
      recursoInicial = this.payload.length ? this.payload : [this.payload];
    } catch (e) {
      recursoInicial = [];
    }

    return {
      itemsPerPage: 5,
      totalPages: 0,

      idEditado: "",
      formEditPessoa: false,
      recursos: [],
      recurso: recursoInicial,
      search: "",

      mask: currencyMask,

      dialogCadastro: false,
      insertComponent: null,
      loadingCadastroComponent: false,
      idsAntesCadastro: new Set(),
      cadastroRapidoRecenteId: null,
      escListenerRegistered: false,
      recursosRequestId: 0,
      tenantContextId: normalizeIdentity(this.$store?.state?.inquilino?.id),
      dialogListagemPadrao: false,
      listagemComponent: null,
      loadingListagemComponent: false,
      recursosCarregados: false,
      erroCarregamentoRecursos: false,
    };
  },

  mounted() {
    if (this.recurso === null) {
      this.recurso = {};
    }
    if (this.exibirListagemDireta) {
      this.carregarConteudoSeletor();
    } else if (!this.seletorOtimizadoAtivo) {
      this.getRecursos();
    }
  },

  beforeDestroy() {
    this.invalidateRecursosRequests();
    this.unregisterEscListener();
  },

  activated() {
    if (
      normalizeIdentity(this.tenantContextId) !==
      normalizeIdentity(this.getCurrentTenantId())
    ) {
      this.resetPorTrocaTenant();
    }
  },

  computed: {
    translatedTitle() {
      return translateIfMessageExists(this.$i18n, this.titulo);
    },

    recursoSelecionado() {
      if (!Array.isArray(this.recurso) || !this.recurso.length) {
        return null;
      }
      const item = this.recurso[0];
      if (
        !item ||
        (typeof item === "object" &&
          !Array.isArray(item) &&
          Object.keys(item).length === 0)
      ) {
        return null;
      }
      return item;
    },

    textoRecursoSelecionado() {
      const item = this.recursoSelecionado;
      if (!item) {
        return "";
      }
      if (typeof this.itemText === "function") {
        return this.itemText(item);
      }
      if (this.normalizedUrlBase === "funcionariopontoperiodos") {
        const inicio = this.formatarDataSelecionada(item.inicioPeriodo);
        const fim = this.formatarDataSelecionada(item.finalPeriodo);
        return [
          inicio ? `${this.$t("Inicio")}: ${inicio}` : "",
          fim ? `${this.$t("Final")}: ${fim}` : "",
        ]
          .filter(Boolean)
          .join(" · ");
      }

      const textoConfigurado = this.getNestedValue(item, this.itemText);
      if (textoConfigurado) {
        return textoConfigurado;
      }

      if (this.normalizedUrlBase === "funcionarios") {
        return [item.matricula, item.nomeSocial || item.nome]
          .filter(Boolean)
          .join(" - ");
      }

      return (
        item.descricao ||
        item.nomeSocial ||
        item.nome ||
        item.fantasia ||
        item.razaoSocial ||
        item.identificador ||
        item.codigo ||
        item.numero ||
        item.id
      );
    },

    seletorOtimizadoAtivo() {
      return (
        !this.selectMultiple &&
        (this.usarListagemPadrao || !this.exibirTabelaInline)
      );
    },

    exibirListagemDireta() {
      return !!(
        this.seletorOtimizadoAtivo &&
        !this.manterCompactoSemSelecao &&
        !this.recursoSelecionado
      );
    },

    seletorContainerProps() {
      if (this.exibirListagemDireta) {
        return {};
      }
      return {
        value: this.dialogListagemPadrao,
        fullscreen: this.$vuetify.breakpoint.smAndDown,
        maxWidth: "1280",
        scrollable: true,
      };
    },

    resolvedListagemNome() {
      return (
        this.listagemNome || URL_LISTAGEM_MAP[this.normalizedUrlBase] || ""
      );
    },

    temListagemPadrao() {
      return !!(
        !this.desabilitarListagemPadrao &&
        this.resolvedListagemNome &&
        componentPaths[this.resolvedListagemNome]
      );
    },

    normalizedHeaders() {
      return (this.headers || []).map((header) => {
        if (!header || typeof header !== "object") {
          return header;
        }

        if (header.sortable === "false") {
          return { ...header, sortable: false };
        }

        if (header.sortable === "true") {
          return { ...header, sortable: true };
        }

        return header;
      });
    },

    headersSelecao() {
      return this.normalizedHeaders.filter(
        (header) => header && header.value !== "actions"
      );
    },

    tableItems() {
      try {
        if (this.payload.length) {
          return [...this.recursos].sort((a, b) => {
            const aRecente =
              this.cadastroRapidoRecenteId !== null &&
              this.cadastroRapidoRecenteId !== undefined &&
              a &&
              a.id === this.cadastroRapidoRecenteId
                ? 0
                : 1;
            const bRecente =
              this.cadastroRapidoRecenteId !== null &&
              this.cadastroRapidoRecenteId !== undefined &&
              b &&
              b.id === this.cadastroRapidoRecenteId
                ? 0
                : 1;
            if (aRecente !== bRecente) {
              return aRecente - bRecente;
            }

            const aSelecionado = this.payload.includes(a) ? 0 : 1;
            const bSelecionado = this.payload.includes(b) ? 0 : 1;
            return aSelecionado - bSelecionado;
          });
        }
      } catch (e) {
        console.log(e);
        return this.recursos;
      }

      try {
        if (typeof this.payload == "object" && this.payload) {
          return [...this.recursos].sort((a, b) => {
            const aRecente =
              this.cadastroRapidoRecenteId !== null &&
              this.cadastroRapidoRecenteId !== undefined &&
              a &&
              a.id === this.cadastroRapidoRecenteId
                ? 0
                : 1;
            const bRecente =
              this.cadastroRapidoRecenteId !== null &&
              this.cadastroRapidoRecenteId !== undefined &&
              b &&
              b.id === this.cadastroRapidoRecenteId
                ? 0
                : 1;
            if (aRecente !== bRecente) {
              return aRecente - bRecente;
            }

            const aSelecionado = a.id == this.payload.id ? 0 : 1;
            const bSelecionado = b.id == this.payload.id ? 0 : 1;
            return aSelecionado - bSelecionado;
          });
        }
      } catch (e) {
        console.log(e);
        return this.recursos;
      }
      return [...(this.recursos || [])].sort((a, b) => {
        const aRecente =
          this.cadastroRapidoRecenteId !== null &&
          this.cadastroRapidoRecenteId !== undefined &&
          a &&
          a.id === this.cadastroRapidoRecenteId
            ? 0
            : 1;
        const bRecente =
          this.cadastroRapidoRecenteId !== null &&
          this.cadastroRapidoRecenteId !== undefined &&
          b &&
          b.id === this.cadastroRapidoRecenteId
            ? 0
            : 1;
        return aRecente - bRecente;
      });
    },

    normalizedUrlBase() {
      if (!this.url) {
        return "";
      }

      return String(this.url)
        .split("?")[0]
        .split("/")[0]
        .replace(/[^a-zA-Z]/g, "")
        .toLowerCase();
    },

    resolvedCadastroUrl() {
      if (this.cadastroUrl) {
        return this.cadastroUrl;
      }

      return URL_CADASTRO_MAP[this.normalizedUrlBase] || "";
    },

    resolvedInsertPermission() {
      if (this.insertPermission) {
        return this.insertPermission;
      }

      if (
        !this.resolvedCadastroUrl ||
        this.resolvedCadastroUrl.indexOf("cadastro.") !== 0
      ) {
        return "";
      }

      const nomeSingular = this.resolvedCadastroUrl.replace("cadastro.", "");
      if (!nomeSingular) {
        return "";
      }

      return `ROLE_${nomeSingular}_Insert`;
    },

    hasCadastroComponent() {
      return !!componentPaths[this.resolvedCadastroUrl];
    },

    showCadastroRapidoButton() {
      return !!(
        this.enableCadastroRapido &&
        this.resolvedCadastroUrl &&
        this.resolvedInsertPermission &&
        this.hasCadastroComponent
      );
    },
  },

  methods: {
    async openListagemPadrao() {
      this.dialogListagemPadrao = true;
      await this.carregarConteudoSeletor();
    },

    async carregarConteudoSeletor() {
      this.erroCarregamentoRecursos = false;

      if (!this.temListagemPadrao) {
        if (!this.recursosCarregados) {
          await this.recarregarRecursosSeletor();
        }
        return;
      }

      if (this.listagemComponent) {
        return;
      }
      this.loadingListagemComponent = true;
      try {
        const componentModule = await componentPaths[
          this.resolvedListagemNome
        ]();
        this.listagemComponent = componentModule.default || componentModule;
      } catch (error) {
        console.log("erro ao carregar listagem para seleção", error);
        this.erroCarregamentoRecursos = true;
      } finally {
        this.loadingListagemComponent = false;
      }
    },

    tentarNovamenteCarregamento() {
      if (this.temListagemPadrao) {
        this.listagemComponent = null;
        this.carregarConteudoSeletor();
        return;
      }
      this.recarregarRecursosSeletor();
    },

    closeListagemPadrao() {
      this.dialogListagemPadrao = false;
    },

    selecionarRecursoDaListagem(item) {
      if (!item) {
        return;
      }
      this.recurso = [item];
      this.closeListagemPadrao();
    },

    selecionarRecursoDaTabela(item) {
      this.selecionarRecursoDaListagem(item);
    },

    async recarregarRecursosSeletor() {
      this.loadingListagemComponent = true;
      this.erroCarregamentoRecursos = false;
      try {
        await this.getRecursos();
      } catch (error) {
        this.erroCarregamentoRecursos = true;
      } finally {
        this.loadingListagemComponent = false;
      }
    },

    limparSelecaoPaginada() {
      this.recurso = [];
      this.$emit("recurso", null);
    },

    getNestedValue(item, path) {
      if (!item || !path || typeof path !== "string") {
        return "";
      }
      return path.split(".").reduce((value, key) => {
        return value === null || typeof value === "undefined" ? "" : value[key];
      }, item);
    },

    formatarDataSelecionada(value) {
      if (!value) {
        return "";
      }
      const dataParaLeitura = this.$options.filters?.dataParaLeitura;
      return dataParaLeitura ? dataParaLeitura(value) : value;
    },

    getCurrentTenantId() {
      return this.$store?.state?.inquilino?.id || null;
    },

    startRecursosRequest() {
      this.recursosRequestId += 1;
      return {
        id: this.recursosRequestId,
        tenantId: this.getCurrentTenantId(),
      };
    },

    isCurrentRecursosRequest(requestContext) {
      return (
        requestContext &&
        requestContext.id === this.recursosRequestId &&
        normalizeIdentity(requestContext.tenantId) ===
          normalizeIdentity(this.getCurrentTenantId())
      );
    },

    invalidateRecursosRequests() {
      this.recursosRequestId += 1;
    },

    resetPorTrocaTenant() {
      this.tenantContextId = normalizeIdentity(this.getCurrentTenantId());
      this.invalidateRecursosRequests();
      this.recursos = [];
      this.recurso = [];
      this.search = "";
      this.cadastroRapidoRecenteId = null;
      this.listagemComponent = null;
      this.dialogListagemPadrao = false;
      this.recursosCarregados = false;
      this.erroCarregamentoRecursos = false;
      if (this.exibirListagemDireta) {
        this.carregarConteudoSeletor();
      } else if (!this.seletorOtimizadoAtivo) {
        this.getRecursos();
      }
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveData();
    },

    getRecursos() {
      const requestContext = this.startRecursosRequest();
      return new Promise((resolve, reject) => {
        DataService.getRecursos(this.url)
          .then((response) => {
            if (!this.isCurrentRecursosRequest(requestContext)) {
              resolve();
              return;
            }
            this.recursos = response.data;
            this.recursosCarregados = true;
            this.erroCarregamentoRecursos = false;
            resolve();
          })
          .catch((error) => {
            if (!this.isCurrentRecursosRequest(requestContext)) {
              resolve();
              return;
            }
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            console.log(error, "error");
            reject(error);
          });
      });
    },

    editRecurso(id) {
      this.idEditado = id;
      this.formEditPessoa = true;
    },

    async loadInsertComponent() {
      if (!this.resolvedCadastroUrl) {
        return;
      }

      this.loadingCadastroComponent = true;
      try {
        if (componentPaths[this.resolvedCadastroUrl]) {
          const componentModule = await componentPaths[
            this.resolvedCadastroUrl
          ]();
          const component = componentModule.default || componentModule;

          if (!component || (!component.template && !component.render)) {
            this.insertComponent = {
              template: "<div>Componente não encontrado ou inválido</div>",
            };
          } else {
            this.insertComponent = component;
          }
        } else {
          this.insertComponent = {
            template: "<div>Componente não encontrado</div>",
          };
        }
      } catch (error) {
        console.log(error);
        this.insertComponent = {
          template: "<div>Erro ao carregar o componente</div>",
        };
      } finally {
        this.loadingCadastroComponent = false;
      }
    },

    async openCadastroModal() {
      this.idsAntesCadastro = new Set(
        (this.recursos || [])
          .map((item) => item && item.id)
          .filter((id) => id !== undefined && id !== null)
      );

      this.dialogCadastro = true;
      await this.loadInsertComponent();
    },

    closeCadastroModal() {
      this.dialogCadastro = false;
      this.insertComponent = null;
    },

    registerEscListener() {
      if (this.escListenerRegistered) {
        return;
      }

      window.addEventListener("keydown", this.handleEscCapture, true);
      this.escListenerRegistered = true;
    },

    unregisterEscListener() {
      if (!this.escListenerRegistered) {
        return;
      }

      window.removeEventListener("keydown", this.handleEscCapture, true);
      this.escListenerRegistered = false;
    },

    onEscCadastroRapido() {
      if (this.dialogCadastro) {
        this.closeCadastroModal();
      }
    },

    handleEscCapture(event) {
      if (!this.dialogCadastro) {
        return;
      }

      if (event.key !== "Escape" && event.key !== "Esc") {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }

      this.closeCadastroModal();
    },

    getNovoRecursoPorDiferenca() {
      const novos = (this.recursos || []).filter((item) => {
        if (!item || item.id === undefined || item.id === null) {
          return false;
        }
        return !this.idsAntesCadastro.has(item.id);
      });

      if (novos.length === 1) {
        return novos[0];
      }

      if (novos.length > 1) {
        return novos
          .slice()
          .sort((a, b) => Number(b.id || 0) - Number(a.id || 0))[0];
      }

      return null;
    },

    getNovoRecursoPorFormData(formData) {
      if (!formData || typeof formData !== "object") {
        return null;
      }

      if (formData.id !== undefined && formData.id !== null) {
        const encontradoPorId = (this.recursos || []).find(
          (item) => item && item.id === formData.id
        );
        if (encontradoPorId) {
          return encontradoPorId;
        }
      }

      if (formData.descricao) {
        const encontradoPorDescricao = (this.recursos || []).find(
          (item) => item && item.descricao === formData.descricao
        );
        if (encontradoPorDescricao) {
          return encontradoPorDescricao;
        }
      }

      if (formData.identificador) {
        const encontradoPorIdentificador = (this.recursos || []).find(
          (item) => item && item.identificador === formData.identificador
        );
        if (encontradoPorIdentificador) {
          return encontradoPorIdentificador;
        }
      }

      return null;
    },

    selecionarNovoRecurso(novoRecurso) {
      if (!novoRecurso) {
        return;
      }

      if (this.selectMultiple) {
        if (!Array.isArray(this.recurso)) {
          this.recurso = [];
        }
        if (!this.recurso.some((item) => item && item.id === novoRecurso.id)) {
          this.recurso = [...this.recurso, novoRecurso];
        }
        return;
      }

      this.recurso = [novoRecurso];
    },

    priorizarRecursoNoTopo(novoRecurso) {
      if (
        !novoRecurso ||
        novoRecurso.id === undefined ||
        novoRecurso.id === null
      ) {
        return;
      }

      const recursosSemNovo = (this.recursos || []).filter((item) => {
        return !(item && item.id === novoRecurso.id);
      });

      this.recursos = [novoRecurso, ...recursosSemNovo];
    },

    async onSubmitSuccessInsert(repeat, formData) {
      await this.getRecursos();

      const novoRecurso =
        this.getNovoRecursoPorDiferenca() ||
        this.getNovoRecursoPorFormData(formData);

      this.cadastroRapidoRecenteId =
        novoRecurso && novoRecurso.id !== undefined ? novoRecurso.id : null;
      this.priorizarRecursoNoTopo(novoRecurso);
      this.selecionarNovoRecurso(novoRecurso);
      this.$emit("submitSuccessInsert", repeat, formData, novoRecurso || null);
      this.closeCadastroModal();
      if (this.seletorOtimizadoAtivo) {
        this.closeListagemPadrao();
      }
    },

    onSubmitErrorInsert() {
      this.$emit("submitErrorInsert");
    },
  },

  watch: {
    "$store.state.inquilino.id": function (newValue, oldValue) {
      if (normalizeIdentity(newValue) === normalizeIdentity(oldValue)) {
        return;
      }
      this.resetPorTrocaTenant();
    },
    recurso: function (newValue) {
      if (Array.isArray(newValue) && newValue.length > 0) {
        if (this.selectMultiple) {
          this.$emit("recurso", newValue);
        } else {
          this.$emit("recurso", newValue[0]);
        }
      }
    },
    payload: function (newValue) {
      this.recurso = newValue
        ? Array.isArray(newValue)
          ? newValue
          : [newValue]
        : [];
    },
    dialogCadastro: function (newValue) {
      if (newValue) {
        this.registerEscListener();
      } else {
        this.unregisterEscListener();
      }
    },
    exibirListagemDireta: function (newValue) {
      if (!newValue) {
        return;
      }
      this.dialogListagemPadrao = false;
      this.carregarConteudoSeletor();
    },
  },
};
</script>

<style scoped>
.selector-paginado {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.selector-paginado__cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
}

.selector-paginado__titulo,
.selector-paginado__rotulo {
  display: block;
  color: #344767;
  font-weight: 700;
}

.selector-paginado__ajuda,
.selector-paginado__rotulo {
  color: #8392ab;
  font-size: 0.75rem;
}

.selector-paginado__selecionado,
.selector-paginado__vazio {
  display: flex;
  align-items: center;
  min-height: 62px;
  padding: 12px 18px;
  border-top: 1px solid #f0f2f5;
  background: #f8f9fa;
}

.selector-paginado__valor {
  overflow: hidden;
  color: #344767;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selector-paginado__vazio {
  color: #8392ab;
}

.selector-paginado__dialog {
  max-height: 92vh;
}

.selector-paginado__inline {
  overflow: hidden;
  border: 1px solid #e9ecef;
  border-radius: 12px;
}

.selector-paginado__inline .selector-paginado__dialog-content {
  min-height: 0;
}

.selector-paginado__dialog-title {
  flex-wrap: nowrap;
  padding: 16px 20px;
}

.selector-paginado__dialog-content {
  min-height: 360px;
}

.selector-paginado__busca {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
}

.selector-paginado__busca .v-input {
  max-width: 520px;
}

.selector-paginado__table::v-deep tbody tr {
  cursor: pointer;
}

.selector-paginado__table::v-deep tbody tr:hover {
  background: #f6f7ff !important;
}

.min-width-0 {
  min-width: 0;
}

.required-mark {
  color: #e53935;
}

@media (max-width: 600px) {
  .selector-paginado__cabecalho {
    align-items: stretch;
    flex-direction: column;
  }

  .selector-paginado__busca {
    align-items: stretch;
    flex-direction: column;
  }

  .selector-paginado__busca .v-input {
    max-width: none;
  }
}
</style>
